// src/utils/formUtils.ts

/**
 * Toggle a single value (for radio-like checkboxes)
 * If the current value is the same as the new value, it clears the value
 * Otherwise, it sets the value to the new value
 * 
 * @param currentValue The current value
 * @param newValue The value to toggle
 * @returns The toggled value
 */
export const toggleValue = (currentValue: string | undefined, newValue: string): string => {
    return currentValue === newValue ? '' : newValue;
  };
  
  /**
   * Toggle a numeric value (for radio-like checkboxes)
   * If the current value is the same as the new value, it clears the value (sets to 0)
   * Otherwise, it sets the value to the new value
   * 
   * @param currentValue The current numeric value
   * @param newValue The numeric value to toggle
   * @returns The toggled numeric value
   */
  export const toggleNumericValue = (currentValue: number | undefined, newValue: number): number => {
    return currentValue === newValue ? 0 : newValue;
  };